import { LanguageViewModel } from "@viewModels/Language.viewModel";
import { createContext } from "react";

interface ILanguagesContext {
  count: number;
  items: Array<LanguageViewModel>;
}

const initialValue: ILanguagesContext = {
  count: 0,
  items: [],
};

export const LanguagesContext = createContext<ILanguagesContext>(initialValue);
